module.exports = __webpack_public_path__ + "static/media/inventarios.7eeb862b.svg";